module.exports = __webpack_public_path__ + "static/media/56_logo.87330ddc.png";